@if (shareMyBetState$ | async; as shareMyBet) {
    @if (shareMyBet.sharingStates[betslipId]; as state) {
        @if (state.isCopyLinkDialogOpen) {
            <div class="share-my-bet__copy-dialog">
                @if (withHeader) {
                    <div class="share-my-bet__copy-header" [ngClass]="enableRedesignedBetCard ? 'share-my-bet-epcot' : isToolbarExpanded()">
                        <span class="share-my-bet__copy-title">{{ sitecore.shareMyBet.messages.CopyTitle }}</span>
                        <span class="share-my-bet__copy-close theme-ex" (click)="closeDialog(betslipId)"></span>
                    </div>
                }
                <div class="share-my-bet__copy-text">{{ sitecore.shareMyBet.messages.CopyMessage }}</div>
                <input type="text" class="share-my-bet__short-uri-text" readonly [value]="state.uri" />
                <div class="share-my-bet__copy-button" (click)="copy(betslipId, state)">{{ getCopyText(state.isCopied) }}</div>
            </div>
        }
    }
}
